/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Reason_CorrectionInputs */

const vi_warehouse_defects_reason_correction = /** @type {(inputs: Warehouse_Defects_Reason_CorrectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều chỉnh sổ sách`)
};

/**

* @param {Warehouse_Defects_Reason_CorrectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_reason_correction = /** @type {((inputs?: Warehouse_Defects_Reason_CorrectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Reason_CorrectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_reason_correction(inputs)
});